import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hide'
})
export class HidePipe implements PipeTransform {
  transform(value: any, stype?: any, limit?: number): any {
    limit = limit ? limit : 4;
    stype = stype ? stype : 'email';
    var hiddenEmail = "";
    let hidden = limit;
    if(value){
    for (let i = 0; i < value.length; i++) { 
      let newval = value.length;
      switch(stype){
        case 'email' : 
          hidden = value.indexOf("@") - limit;
          newval = value.indexOf("@");break;
        case 'phone' : 
          hidden = value.length - (limit + 2);
          newval = value.length - 2;break;
      }
      
      if (i >= hidden && i < newval ) {
        hiddenEmail += "*";
      } else {
        hiddenEmail += value[i];
      }
      }
    }
    return hiddenEmail ;
  }

}